export type OfflineAction = {
  type: string;
  body: boolean;
};

export type OfflineState = {
  offline: boolean;
};

const INITIAL_STATE: OfflineState = {
  offline: false,
};

export const setOffline = (offline: boolean): OfflineAction => {
  return {
    type: 'offline',
    body: offline,
  };
};

type OfflineReducer = (state: OfflineState, action: OfflineAction) => OfflineState;

const reducer: OfflineReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'setOffline':
      return { ...state, main: action.body };
    default:
      return state;
  }
};

export default reducer;
